import { render, staticRenderFns } from "./SteamVideos.vue?vue&type=template&id=bf2f148e&"
import script from "./SteamVideos.vue?vue&type=script&lang=js&"
export * from "./SteamVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf2f148e')) {
      api.createRecord('bf2f148e', component.options)
    } else {
      api.reload('bf2f148e', component.options)
    }
    module.hot.accept("./SteamVideos.vue?vue&type=template&id=bf2f148e&", function () {
      api.rerender('bf2f148e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/SteamVideos.vue"
export default component.exports